<mat-paginator
  *ngIf="service?.pageData$ | async as pageData"
  [length]="pageData.totalItems"
  [pageSize]="pageData.pageSize"
  [pageIndex]="pageData.pageIndex"
  [pageSizeOptions]="service.pageSizes"
  (page)="changePageEvent($event)"
>
</mat-paginator>

<mat-paginator
  *ngIf="paginationWithoutService"
  [length]="dataset.data.length"
  [pageSizeOptions]="[ 10, 30, 50, 100 ]"
></mat-paginator>
